import webBiLogger from '@wix/web-bi-logger';

import { getConfig } from '../../../config';

import { BiErrorLogger, BiErrorParams } from './bi-error-logger.types';

interface BiErrorParamsToSend extends BiErrorParams {
  errc: number;
  errn: string;
  sev?: number;
}

export function biErrorLoggerFactory({ artifactVersion }): BiErrorLogger {
  const defaultErrorParams = {
    src: 25,
    evid: 10,
    artifactVersion,
    cat: 1,
    iss: 1,
    sev: 10,
  };

  const biErrorLogger = webBiLogger
    .factory({
      endpoint: 'trg',
      host: getConfig().api.biUrl,
    })
    .updateDefaults(defaultErrorParams)
    .logger();

  return {
    createLoggingCatcher(biEvent) {
      return (reason) => {
        this.logError(biEvent, reason);
        return Promise.reject(reason);
      };
    },

    logError(event, p1?, p2?, p3?, p4?) {
      const eventParams: BiErrorParamsToSend = {
        errc: event.id,
        errn: event.name,
      };
      if (event.severity) {
        eventParams.sev = event.severity;
      }
      if (p1) {
        if (p1 instanceof Error) {
          p1 = p1.message;
        }
        eventParams.p1 = p1;
      }
      if (p2) {
        eventParams.p2 = p2;
      }
      if (p3) {
        eventParams.p3 = p3;
      }
      if (p4) {
        eventParams.p4 = p4;
      }
      return biErrorLogger.log(eventParams);
    },
  };
}
